import { NPLEvent } from '../../../types/events';
import { PageViewNPL } from '../../../types/datalayer/pageview-npl';

export default (nplLoad: NPLEvent): PageViewNPL => {
  const freightType: Record<string, string> = { EXPRESS: 'Receba em Casa', PICK_UP_IN_STORE: 'Pegue na Loja' };
  const event = { ...nplLoad.detail } as PageViewNPL;
  event.event = 'pageview_lojas_proximas';
  event.pagetype = 'O2O-NPL';

  if (event.O2ODeliveryType) {
    event.O2ODeliveryType = freightType[event.O2ODeliveryType];
  }

  return event;
};
